import React, { useState } from 'react'
import { AddFoodComponent } from '../Components/Food/AddFoodComponent';
import { AllFoodComponent } from '../Components/Food/AllFoodComponent';
import { EditFoodComponent } from '../Components/Food/EditFoodComponent';
import { FieldComponent } from '../Components/Field/FieldComponent';
// ======================================================================
export const Food = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [id, setId] = useState(0);
    // ======================================================================
    return (
        <>
            {view == "All" ?
                <AllFoodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onAddClick={() => setView("Add")}
                    onEdit={(id) => { setId(id); setView("Edit") }}
                    onRowDeleted={() => { setVersion(version + 1); }}
                /> : <></>
            }

            {
                view === "Add" ?
                    <AddFoodComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        rowInserted={() => {
                            setView("All"); if (currentPage != 1)
                                setCurrentPage(1);
                            else
                                setVersion(version + 1);
                        }}
                        cancelInsert={() => { setView("All"); }} />
                    : <></>
            }
            {view === "Edit" ?
                <EditFoodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    id={id}
                    rowUpdated={() => { setView("All"); setVersion(version + 1); }}
                    cancelEdit={() => { setView("All"); }} />
                :
                <></>
            }
        </>

    )

}
